export default {
  // Navigation
  'nav.about': 'About Us',
  'nav.services': 'Services',
  'nav.approach': 'Our Approach',
  'nav.cases': 'Case Studies',
  'nav.team': 'Team',
  'nav.contacts': 'Contacts',
  
  // Hero Section
  'hero.title': 'Systematic Marketing and Artificial Intelligence: Your Key to Stable Sales Growth',
  'hero.subtitle': 'We turn chaos into a system. We combine expert experience with the precision of AI algorithms to scale your business.',
  'hero.cta1': 'Get Growth Strategy',
  'hero.cta2': 'Discuss Project',
  'hero.formTitle': 'Is Your Marketing Working at 100% or Draining Your Budget?',
  'hero.formSubtitle': 'Don\'t guess. Get an honest outside perspective. Sign up for a free 20-minute express diagnostic of your project.',
  'hero.formBenefitsTitle': 'What you will learn:',
  'hero.formBenefit1': 'Where you\'re losing customers right now (finding "holes" in the funnel)',
  'hero.formBenefit2': '3 non-obvious growth points for scaling revenue',
  'hero.formBenefit3': 'How AI can reduce your advertising costs',
  'hero.formName': 'Name',
  'hero.formPhone': 'Phone',
  'hero.formWebsite': 'Website link',
  'hero.formWebsiteOptional': '(optional)',
  'hero.formSubmit': 'Get Growth Strategy',
  'hero.formPrivacy': 'By clicking the button, you agree to the privacy policy',
  'hero.formSuccess': 'Application sent! We will contact you shortly.',
  'hero.formError': 'An error occurred. Please try again.',
  
  // Pain Points
  'pain.title': 'Familiar Situation?',
  'pain.point1.title': 'Hiring freelancers on a case-by-case basis',
  'pain.point1.desc': 'And waiting for a miracle that never happens?',
  'pain.point2.title': 'Draining budgets',
  'pain.point2.desc': 'On Yandex and Google with no visible results?',
  'pain.point3.title': 'Have a feeling',
  'pain.point3.desc': '"I\'m doing something wrong", but no understanding of how to fix it?',
  'pain.conclusion': 'Chaotic actions without a system only lead to loss of time and money',
  
  // Solution
  'solution.title': 'What is Systematic Marketing?',
  'solution.subtitle': 'Your key to stable growth and sales',
  'solution.problemTitle': 'Marketing Chaos — Enemy of Your Profit',
  'solution.problemDesc': 'Most companies live in a state of "marketing chaos": sporadic advertising launches, changing contractors, no understanding of which ruble brought profit and which was wasted.',
  'solution.defTitle': 'Systematic Marketing — the opposite of chaos',
  'solution.defDesc1': 'This is an approach where marketing is viewed not as a set of disparate actions (launched Direct, wrote a post), but as a single organism working for predictable financial results.',
  'solution.defDesc2': 'This is the foundation that turns clicks into real, loyal customers, and every ruble invested brings measurable profit.',
  'solution.pillarsTitle': 'Three Pillars of Systematic Marketing',
  'solution.pillarsSubtitle': 'Unity of three elements',
  'solution.pillarsDesc': 'Systematic marketing rests on the synergy of three key components that work as a single mechanism',
  
  // Services
  'services.title': 'Our Services',
  'services.subtitle': 'Choose a ready-made solution or we\'ll create an individual strategy for your business',
  'services.cta': 'Calculate service cost',
  
  // How We Work
  'howWeWork.title': 'How We Work',
  'howWeWork.subtitle': '5 stages of building a system — step-by-step process of transforming your marketing',
  
  // Case Studies
  'cases.title': 'Case Studies: How the System Works in Practice',
  'cases.subtitle': 'We don\'t hide results. Here are examples of how implementing strategy and end-to-end analytics affects revenue in real time.',
  
  // Why Us
  'whyUs.title': 'Why Us?',
  'whyUs.subtitle': 'We are your strategic partner, not just a contractor',
  'whyUs.reason1.title': 'AI-Based Guarantee',
  'whyUs.reason1.desc': 'We base expenses on accurate models, not guesses. Artificial intelligence analyzes millions of data points for optimal decisions.',
  'whyUs.reason2.title': 'Secret Weapon',
  'whyUs.reason2.desc': 'Technologies your competitors don\'t have. We use cutting-edge AI tools for forecasting and automation.',
  'whyUs.reason3.title': 'Your Time is Valuable',
  'whyUs.reason3.desc': 'We take care of routine, you focus on business. Full process automation frees your resources for strategic development.',
  
  // Results
  'results.title': 'What Will You Get After System Implementation?',
  'results.subtitle': 'Concrete results that will change your business',
  
  // About
  'about.title': 'Evolution from Top Expert to Founder',
  'about.subtitle': 'We don\'t believe in intuitive marketing. We believe in data accuracy, psychology depth, and algorithm speed.',
  
  // Lead Form
  'leadForm.title': 'Ready to Turn Chaos into Stable Growth?',
  'leadForm.subtitle': 'Leave a request for a free diagnostic of your marketing. We\'ll show growth points using AI analysis.',
  'leadForm.name': 'Your name',
  'leadForm.phone': 'Phone',
  'leadForm.website': 'Website',
  'leadForm.websiteOptional': '(optional)',
  'leadForm.messenger': 'Preferred messenger',
  'leadForm.messengerPlaceholder': 'Choose messenger',
  'leadForm.telegram': 'Telegram',
  'leadForm.whatsapp': 'WhatsApp',
  'leadForm.phoneCall': 'Phone call',
  'leadForm.submit': 'Sign up for diagnostic',
  'leadForm.success': '✓ Application sent! We will contact you shortly.',
  'leadForm.error': 'An error occurred. Please try again.',
  'leadForm.privacy': 'By clicking the button, you agree to the privacy policy',
  
  // Footer
  'footer.company': 'Systematic Marketing',
  'footer.description': 'We turn chaos into a system. We combine expert experience with the precision of AI algorithms.',
  'footer.services': 'Services',
  'footer.company.title': 'Company',
  'footer.contacts': 'Contacts',
  'footer.address': '109202, Moscow, 2nd Karacharovskaya St., Building 1, Structure 1, Room 6/2',
  'footer.rights': 'Systematic Marketing. All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Use',
  
  // Common
  'common.readMore': 'Read More',
  'common.contactUs': 'Contact Us',
  'common.learnMore': 'Learn More',
  'common.loading': 'Loading...',
  'common.submit': 'Submit',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
};
